/**
 * Email gate — renders the email capture form and handles unlock.
 */

const WORKER_URL = 'https://bird-contact-proxy.chris-781.workers.dev';

export function renderEmailGate(result) {
  // Stash stats for the Worker POST
  const { bloatDistribution } = result.chatgptTax;
  const total = bloatDistribution.green + bloatDistribution.yellow + bloatDistribution.red;
  window.__fatchatStats = {
    chatCount: result.conversations.length,
    bloatPercent: ((bloatDistribution.yellow + bloatDistribution.red) / total * 100).toFixed(0),
    taxHours: result.chatgptTax.taxPaid.totalHours.toFixed(1),
  };

  return `
    <section class="section gate-section" id="section-gate">
      <div class="gate-cta">
        <h3>Check the Back Pocket</h3>
        <p>
          5 personalized fixes tucked inside, based on your data. Your chats are already analyzed &mdash;
          drop your email to pull them out.
        </p>
        <form class="gate-form" id="gate-form">
          <input class="gate-input" type="email" id="gate-email" placeholder="you@email.com" required autocomplete="email">
          <button class="gate-submit" type="submit">Show My Plan</button>
        </form>
      </div>
    </section>
  `;
}

/**
 * Wire up the gate form and check for bypass conditions:
 * - ?demo=1 URL param → auto-unlock
 * - localStorage fatchat-unlocked → returning visitor
 */
export function initGate() {
  const params = new URLSearchParams(window.location.search);

  // Auto-unlock for demo or returning visitors
  if (params.get('demo') === '1' || localStorage.getItem('fatchat-unlocked')) {
    unlockGatedContent();
    return;
  }

  const form = document.getElementById('gate-form');
  if (!form) return;

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    handleGateSubmit();
  });
}

export function handleGateSubmit() {
  const emailInput = document.getElementById('gate-email');
  if (!emailInput) return;

  const email = emailInput.value.trim();
  if (!email) return;

  // Store for returning visitor bypass
  localStorage.setItem('fatchat-unlocked', '1');
  localStorage.setItem('fatchat-email', email);

  // Send to Bird via Worker (fire-and-forget — don't block unlock)
  const stats = window.__fatchatStats || {};
  fetch(WORKER_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      email,
      chatCount: stats.chatCount,
      bloatPercent: stats.bloatPercent,
      taxHours: stats.taxHours,
    }),
  }).catch(() => {}); // Silent fail — gate works regardless

  unlockGatedContent();
}

export function unlockGatedContent() {
  const container = document.getElementById('results-container');
  if (!container) return;

  container.classList.add('unlocked');

  // Hide the gate section
  const gateSection = document.getElementById('section-gate');
  if (gateSection) gateSection.style.display = 'none';

  // Re-observe gated sections for scroll-reveal
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  container.querySelectorAll('.gated-section:not(.visible)').forEach(el => {
    observer.observe(el);
  });

  // Smooth scroll to first gated section
  const firstGated = container.querySelector('.gated-section');
  if (firstGated) {
    setTimeout(() => {
      firstGated.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  }
}
